import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
<h1>{`I'm Cale Corwin`}</h1>
<blockquote>
<p parentName="blockquote">{`I've spent my career developing digital solutions and automating workflows. My project management background and strong technical skills make me an ideal leader to take your project from whiteboard to profit.`}</p>
</blockquote>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      